import type { ReactNode } from 'react'

export type CheckTone = 'ok' | 'warn' | 'info'

const TONE: Record<CheckTone, { dot: string; text: string }> = {
  ok: { dot: 'bg-mint', text: 'text-mint' },
  warn: { dot: 'bg-coral', text: 'text-coral' },
  info: { dot: 'bg-teal', text: 'text-teal' },
}

export function CheckRow({
  label,
  value,
  tone,
  hint,
  children,
}: {
  label: string
  value: string
  tone: CheckTone
  hint?: string
  children?: ReactNode
}) {
  const styles = TONE[tone]
  return (
    <div className="border-rule grid grid-cols-1 gap-1 border-b py-4 last:border-b-0 sm:grid-cols-[minmax(0,15rem)_1fr] sm:gap-6">
      <div className="text-muted text-sm font-bold tracking-wide uppercase">{label}</div>
      <div>
        <p className={`m-0 flex items-center gap-2 font-bold ${styles.text}`}>
          <span
            aria-hidden="true"
            className={`inline-block h-2.5 w-2.5 rounded-full ${styles.dot}`}
          />
          {value}
        </p>
        {hint ? <p className="text-muted m-0 mt-1 text-sm">{hint}</p> : null}
        {children}
      </div>
    </div>
  )
}
